import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class QreVarianceExplainService {
  constructor(private http: HttpClient) {}

  loadData(baseUrl: string, actionCode: string, params: Record<string, any>): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=${actionCode}`;
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveData(baseUrl: string, actionCode: string, jsonObj: any[], jsonSettings: any[], globalService: any, filterParams: any = {}): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;
    let params: any = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ jsonObj: JSON.stringify(jsonObj) }, params);
    params = _.extend({ jsonSettings: JSON.stringify(jsonSettings) }, params);
    params.process_name = 'RECLASS_TBBS_SAVE';
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, String(params[key]));
      }
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
